module.exports = __webpack_public_path__ + "static/assets/884c0d7bca620c451298fde7f1142afb.png";